var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center"},[_c('div',{staticClass:"flex justify-center items-center"},[_c('img',{staticClass:"w-64 h-64",attrs:{"src":require(`@/assets/img/loader.gif`),"alt":"loading..."}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }